import { Component, Input } from '@angular/core';
import { FontAlign } from '../../../../../elements/resource/types/shape.type';
import { Store } from '@ngrx/store';
import { setDescriptorValue } from '../../../../store/editor.crud.actions';
import { bulkUpdateFinish } from '../../../../store/editor.actions';

@Component({
  selector: 'nw-font-align-selector',
  templateUrl: './font-align-selector.component.html',
  styleUrls: ['./font-align-selector.component.scss'],
})
export class FontAlignSelectorComponent {
  currentFontAlign: FontAlign = 'left';

  constructor(private readonly store: Store) {}

  @Input()
  set fontFamily(val: FontAlign) {
    // console.log('current-font-align', val);
    this.currentFontAlign = val || 'left';
  }

  clickHandler() {
    // -- // -- //
    switch (this.currentFontAlign) {
      case 'left':
        this.save('center');
        break;
      case 'center':
        this.save('right');
        break;
      case 'right':
        this.save('left');
        break;
    }
  }

  save(value: FontAlign) {
    // -- // -- // -- //
    this.store.dispatch(
      setDescriptorValue({
        key: 'textConfig',
        innerKey: 'align',
        value,
      }),
    );
    this.store.dispatch(bulkUpdateFinish());
  }
}
